import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import './offeringInvestors.scss';
import Dashboard from '../../component/Dashboard';
import { getOfferingDetail, doOfferingDetailRes } from '../../actions/offeringDetailActions';
import { fetchOfferingUserInfo, doOfferingUserInfoRes } from '../../actions/offeringUserInfoActions';
import { numberWithCommasAndDollar, convertDateTimeFormat, numberWithCommas} from '../../helper/helper';
import moment from 'moment';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid,
  Label } from 'recharts';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import GridTable from '@nadavshaar/react-grid-table';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Tooltips from '@material-ui/core/Tooltip';
const DialogTitle = withStyles(theme => ({
    root: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(),
      top: theme.spacing(),
      color: theme.palette.grey[500],
    },
	}))(props => {
	const { children, classes, onClose } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root}>
		<Typography variant="h6">{children}</Typography>
		{onClose ? (
			<IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
			<CloseIcon />
			</IconButton>
		) : null}
		</MuiDialogTitle>
	);
});
  
const DialogContent = withStyles(theme => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
}))(MuiDialogContent);

const CustomizedDot = (props) => {
	const {
	  cx, cy
	} = props;
  
  
	return (
		<circle cx={cx - 0} cy={cy - 0} r={6} stroke="black" strokeWidth={2} fill="green" viewBox="0 0 1024 1024" />
	);
  };
let sortedData = [];
class OfferingInvestorsComponent extends React.PureComponent {

	constructor(props) {
		super(props);

		let columns = [
			{ id: 1, field: 'user_id', label: 'User Id', visible: true, sortable: true, cellRenderer: this.offeringsTemp },
			{ id: 2, field: 'created_at1', label: 'Order Date', visible: true, sortable: true, cellRenderer: this.offeringsTemp },
			{ id: 3, field: 'allocated_shares', label: 'Allocated Shares', visible: true, sortable: true, cellRenderer: this.sharesTemplate },
			{ id: 4, field: 'requested_amount', label: 'Requested Amount', visible: true, sortable: true, cellRenderer: this.requestedAmountTemplate },
			{ id: 5, width: '240px', field: 'requested_shares', label: 'Requested Shares', visible: true, sortable: true, cellRenderer: this.sharesTemplate },
			{ id: 6, field: 'status', label: 'Status', visible: true, sortable: true, cellRenderer: this.statusTemplate },
		];
		  
		this.state = {
			active: true,
			closed: false,
			cancelled: false,
			searching: '',
			cols: columns,
			multiSelect: [],
			offeringDetailData: [],
			allOfferingDetails: '',
			isActiveStatus: false,
			openOrderModal: false,
			orderList: []
		};
		this.colOptions = [];
		for (let col of columns) {
			this.colOptions.push({ label: col.header, value: col });
		}
	}

	componentDidMount() {
		if(this.props.location.state.data){
			this.setState({
			  allOfferingDetails: this.props.location.state.data
			})
			if(this.props.location.state.data.status === "active"){
			  this.setState({
				// multiSelect:[
				// 	{label: 'Active', value: true, id: 1},
				// 	{label: 'Effective', value: false, id: 4},
				// 	{label: 'Cancelled', value: false, id: 3},
				// ],
				isActiveStatus:true
			  })
			} else {
			  this.setState({
				// multiSelect:[
				// 	{label: 'Closed', value: true, id: 2},
				// 	{label: 'Cancelled', value: false, id: 3},
				// ],
				isActiveStatus: false
			  })
			}
		}
		this.props.getOfferingDetail(this.props.match.params.id);
	}

	static getDerivedStateFromProps(props, state) {
		if (props.offeringDetailRes) {
			if (props.offeringDetailRes.data && props.offeringDetailRes.data.offeringDetail) {
				if (props.offeringDetailRes.data.offeringDetail.message === 'Success') {
					return {
						offeringDetailData: props.offeringDetailRes.data.offeringDetail.data,
					};
				}
			}
		}
		return state;
	}
	searchOffering = (event) => {
		this.setState({
			searching: event.target.value
		})
	}
	offeringsTemp = ({ tableManager, value, field, data, column, colIndex, rowIndex }) => {
		if (value) {
			return  <div className='rgt-cell-inner rgt-text-truncate' style={{overflow: 'hidden', display: 'flex', alignItems: 'center'}}>
				<Tooltips title={(value !== undefined || value !== null) ? value : ''} interactive={!value} >
					<div className="text-one-line" style={{width: '90%'}} >{value}</div>
				</Tooltips>
				{
					value !== '' &&
					<Tooltips title={'Copy to clipboard'} interactive >
						<Button style={{padding: 4, minWidth: 10, color: "#7e817c"}} onClick={() =>  navigator.clipboard.writeText(value)} > <FileCopyIcon fontSize="small" style={{fontSize: 14}}/> </Button>
					</Tooltips>
				}
			</div>;
		}
	}
	statusTemplate = ({tableManager, value, field, data, column, colIndex, rowIndex}) => {
		let classNames = 'rgt-cell-inner rgt-text-truncate ';
		if (data.status === 'cancelled') {
		  classNames = 'rgt-cell-inner rgt-text-truncate red_color';
		}
		return  <div className={classNames} style={{overflow: 'hidden', display: 'flex', alignItems: 'center'}}>
			<Tooltips title={(value !== undefined || value !== null) ? value : ''} interactive={!value} >
				<div className="text-one-line" style={{width: '90%'}} >{value === null ? '' : value}</div>
			</Tooltips>
			{
				value !== '' &&
				<Tooltips title={'Copy to clipboard'} interactive >
					<Button style={{padding: 4, minWidth: 10, color: "#7e817c"}} onClick={() =>  navigator.clipboard.writeText(value)} > <FileCopyIcon fontSize="small" style={{fontSize: 14}}/> </Button>
				</Tooltips>
			}
		</div>;
	}
	requestedAmountTemplate = ({tableManager, value, field, data, column, colIndex, rowIndex}) => {
		return  <div className='rgt-cell-inner rgt-text-truncate' style={{overflow: 'hidden', display: 'flex', alignItems: 'center'}}>
			<Tooltips title={(value !== undefined || value !== null) ? numberWithCommasAndDollar(value) : ''} interactive={!value} >
				<div className="text-one-line" style={{width: '90%'}} >{numberWithCommasAndDollar(value)}</div>
			</Tooltips>
			{
				value !== '' &&
				<Tooltips title={'Copy to clipboard'} interactive >
					<Button style={{padding: 4, minWidth: 10, color: "#7e817c"}} onClick={() =>  navigator.clipboard.writeText(value)} > <FileCopyIcon fontSize="small" style={{fontSize: 14}}/> </Button>
				</Tooltips>
			}
		</div>;
	}
	sharesTemplate = ({tableManager, value, field, data, column, colIndex, rowIndex}) => {
		return  <div className='rgt-cell-inner rgt-text-truncate' style={{overflow: 'hidden', display: 'flex', alignItems: 'center'}}>
			<Tooltips title={(value !== undefined || value !== null) ? numberWithCommas(value) : ''} interactive={!value} >
				<div className="text-one-line" style={{width: '90%'}} >{numberWithCommas(value)}</div>
			</Tooltips>
			{
				value !== '' &&
				<Tooltips title={'Copy to clipboard'} interactive >
					<Button style={{padding: 4, minWidth: 10, color: "#7e817c"}} onClick={() =>  navigator.clipboard.writeText(value)} > <FileCopyIcon fontSize="small" style={{fontSize: 14}}/> </Button>
				</Tooltips>
			}
		</div>;
	}

	goBackNavigate() {
		this.props.history.goBack()
	}

	formatXAxis(tickItem) {
		const date = new Date(tickItem);
		return moment(date.toISOString()).format('DD MMM');
	}


	renderTooltip(item) {
		if (item && item.payload && item.payload.length > 0) {
			return <div style={{ padding: 8, background: '#fff'}}>
				<p style={{ fontWeight: 'bold', fontSize: 15 }} >{item.payload[0].payload.Date}</p>
				<p style={{ fontWeight: 'bold', fontSize: 15, color: '#8DC73F' }}>{numberWithCommasAndDollar(item.payload[0].payload.Amount)}</p>
				<p style={{ fontWeight: 'bold', fontSize: 15, color: '#0A5074' }}># {item.payload[0].payload.countInvestor}</p>
			</div>
		}

	}
	handleClick = (event) => {
		if (event && event.payload) {
			let orders = [];
			for (let item of this.state.offeringDetailData) {
				if (convertDateTimeFormat(item.created_at) === event.payload.Date) {
					orders.push(item)
				}
			}
			this.setState({
				orderList: orders,
				openOrderModal: true
			})
		}
	}
	closeOrderModal = () => {
		this.setState({
			openOrderModal: false
		})
	}
	
	export = () => {
		let csvContent = 'data:text/csv;charset=utf-8,';
		csvContent += 'User Id, Order Date, Allocated Shares, Requested Amount, Requested Shares, Status \r\n';
		this.state.offeringDetailData.forEach(function (rowArray) {
			const newRow = rowArray.user_id + ',' + rowArray.created_at + ',' + rowArray.allocated_shares + ',' + rowArray.requested_amount + ',' + rowArray.requested_shares + ',' + rowArray.status;
			csvContent += newRow + '\r\n'; // add carriage return
		});
		const encodedUri = encodeURI(csvContent);
		const link = document.createElement('a');
		link.setAttribute('href', encodedUri);
		link.setAttribute('download', 'offering.csv');
		document.body.appendChild(link); // Required for FF
		link.click();
	}
	onColumnToggle = (event) => {
		if (event.value.length > 0) {
		  	this.setState({cols: event.value});
		}
	}
	render() {
		const { offeringDetailData, allOfferingDetails } = this.state;
		let customerFilter=[];

		let chartData = [];

		let statisticData = []
		let statisticDataLinkedToShares = []

		let largestOrder = 0;
		let smallestOrder = 0;
		let medianOrder = 0;
		let hundreds = 0;
		let twoPointFiveThousands = 0;


		if (offeringDetailData) {

			let newOrderData = [];
			for (let items of offeringDetailData) {
				newOrderData.push(items);


				//statistics for printing largest, smallest, median and more
				statisticData.push(items.requested_amount)
				statisticDataLinkedToShares.push(items.requested_shares)
			}
			largestOrder = Math.max(...statisticData)
			smallestOrder = Math.min(...statisticData)
			const mid = Math.floor(statisticData.length / 2)
			let numb = [...statisticData].sort((a, b) => a - b);
			medianOrder = statisticData.length % 2 !== 0 ? numb[mid] : (numb[mid - 1] + numb[mid]) / 2;

			// The round lot is 100 shares and the Nasdqa req of 2500 is $2500
			for (let i = 0; i < statisticData.length; i++) {
				if (statisticData[i] >= 2500) {
					twoPointFiveThousands += 1
				}
			}
			for (let i = 0; i < statisticDataLinkedToShares.length; i++) {
				if (statisticDataLinkedToShares[i] >= 100) {
					hundreds += 1
				}
			}

			if (newOrderData && newOrderData.length > 0) {
				if (convertDateTimeFormat(newOrderData[0].created_at) !== convertDateTimeFormat(allOfferingDetails.created_at)) {
					newOrderData.push({ created_at: allOfferingDetails.created_at, requested_amount: 0, status: 'active', investCount: 0 }, { created_at: allOfferingDetails.created_at, requested_amount: 0, status: 'closed', investCount: 0 });
				}
			}

			sortedData = newOrderData.sort((a, b) => Date.parse(a.created_at) - Date.parse(b.created_at));
			let requestedAmount = 0;
			let countInvestor = 0;
			for (let items of sortedData) {
				if (this.state.isActiveStatus && items.status === 'active') {
					requestedAmount = requestedAmount + items.requested_amount;

					let graphTime = convertDateTimeFormat(items.created_at);

					let checkCount = 0;
					let chartDataIndex = 0;
					for (let chartItem of chartData) {
						if (chartItem.Date === graphTime) {
							requestedAmount = chartItem.Amount + items.requested_amount;
							countInvestor = chartItem.countInvestor + 1;
							checkCount = 1;
							chartData[chartDataIndex].Amount = requestedAmount;
							chartData[chartDataIndex].countInvestor = countInvestor;
							break;
						}
						chartDataIndex++;
					}
					if (checkCount === 0) {
						let investorCount = 0;
						if (chartData.length > 0) {
							investorCount = chartData[chartData.length - 1].countInvestor + 1;
						}
						chartData.push({ Date: graphTime, Amount: requestedAmount, countInvestor: investorCount });
					}
				}

				if (!this.state.isActiveStatus && items.status === 'closed') {
					requestedAmount = requestedAmount + items.requested_amount;
					let graphTime = convertDateTimeFormat(items.created_at);

					let checkCount = 0;
					let chartDataIndex = 0;

					for (let chartItem of chartData) {
						if (chartItem.Date === graphTime) {
							requestedAmount = chartItem.Amount + items.requested_amount;
							countInvestor = chartItem.countInvestor + 1;
							checkCount = 1;
							chartData[chartDataIndex].Amount = requestedAmount;
							chartData[chartDataIndex].countInvestor = countInvestor;
							break;
						}
						chartDataIndex++;
					}
					if (checkCount === 0) {
						let investorCount = 0;
						if (chartData.length > 0) {
							investorCount = chartData[chartData.length - 1].countInvestor + 1;
						}
						chartData.push({ Date: graphTime, Amount: requestedAmount, countInvestor: investorCount });
					}
				}
			}
		}
		if(offeringDetailData){
			if(this.state.active===true || this.state.cancelled===true || this.state.closed===true){
	  
			  if(this.state.isActiveStatus){
				for (let items of offeringDetailData){
					if(items.status ==='active'){
					  customerFilter.push(items);
					}
					if(items.status ==='effective'){
					  customerFilter.push(items);
					}
					if(items.status ==='cancelled'){
					  customerFilter.push(items);
					}

					// if(items.status ==='active' && this.state.multiSelect[1].value === true){
					//   customerFilter.push(items);
					// }
					// if(items.status ==='effective' && this.state.multiSelect[3].value===true){
					//   customerFilter.push(items);
					// }
					// if(items.status ==='cancelled' && this.state.multiSelect[1].value===true){
					//   customerFilter.push(items);
					// }
					if(items.created_at===null || items.created_at==="Not Available"){
						items.created_at="Not Available";
					}else{
						items.created_at1 = convertDateTimeFormat(items.created_at);
					}
				}
			  }
			  
			  if(!this.state.isActiveStatus){
				for (let items of offeringDetailData){
					if(items.status ==='closed'){
					  customerFilter.push(items);
					}
					if(items.status ==='cancelled'){
					  customerFilter.push(items);
					}
					// if(items.status ==='closed' && this.state.multiSelect[0].value===true){
					//   customerFilter.push(items);
					// }
					// if(items.status ==='cancelled' && this.state.multiSelect[1].value===true){
					//   customerFilter.push(items);
					// }
					if(items.created_at===null || items.created_at==="Not Available"){
						items.created_at="Not Available";
					}else{
						items.created_at1 = convertDateTimeFormat(items.created_at);
					}
				}
			  }
	  
			}else{
			  customerFilter=[];
			}
		  }
		customerFilter = this.state.searching ? customerFilter.filter(row => row.status.toLowerCase().indexOf(this.state.searching.toLowerCase()) > -1) : customerFilter;

		let totalRequestedAmount = 0;
		let totalRequestedShare = 0;
		if (customerFilter.length > 0) {

			for (let items of customerFilter) {
				totalRequestedAmount = Number(totalRequestedAmount) + Number(items.requested_amount);
				totalRequestedShare = Number(totalRequestedShare) + Number(items.requested_shares);

			}
		}

		let headers =   <div className="row">
				<div  className="col-md-6" style={{fontSize: 18, fontWeight: 'bold'}}>
				Order Details
				</div>
				
				<div  className="col-md-6" style={{textAlign: 'right'}}>
					<Button variant="contained" color="primary" className="btn" onClick={this.export}>Download CSV</Button>
				</div>
			</div>

		
		return (
			<Dashboard title="ClickIPO Underwriter - Offering Investors" pageTitle="Offering Investors" >
				<div className="offering_order_content">
					<div className="content inline">
						<div className="row offering-detail-subheader">
							<div className="col-md-12">
							<div className="row" style={{marginTop: 10, marginBottom: 10}}>
								<div className="col-md-3">
									<div className="offering-detail-name offeringDeatiltop_bar">	
										{
										allOfferingDetails &&
										<div ><ArrowBackIosIcon onClick={() => { this.goBackNavigate(); }} style={{cursor: 'pointer'}} /> {allOfferingDetails.name}</div>
										}
									</div>
								</div>
								<div className="col-md-9">
								<div className="row">
									<div className="col-md-6">
										<div className="offering-detail-top-bar">
											<div className="row">
											<div className="col-md-8">
												<div style={{fontSize: 16,fontWeight: 'bold',color: '#678899'}}>Total Requested Amount : </div>
											</div>
											<div className="col-md-4">
												<div style={{fontSize: 16,fontWeight: 'bold',color: '#678899'}}>{numberWithCommasAndDollar(totalRequestedAmount)}</div>
											</div>
											</div>
											<div className="row">
											<div className="col-md-8">
												<div style={{fontSize: 16,fontWeight: 'bold',color: '#678899',marginTop: 10}}>Total Requested Shares : </div>
											</div>
											<div className="col-md-4">
												<div style={{fontSize: 16,fontWeight: 'bold',color: '#678899',marginTop: 10}}>{numberWithCommas(totalRequestedShare)}</div>
											</div>
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="offering-detail-top-bar">
											{
											allOfferingDetails &&

											<div className="row">
												<div className="col-md-8">
												<div style={{fontSize: 16,fontWeight: 'bold',color: '#678899'}}>Total Investor Count : </div>
												</div>
												<div className="col-md-4">
												<div style={{fontSize: 16,fontWeight: 'bold',color: '#678899'}}>#{allOfferingDetails.total_requested_investors?allOfferingDetails.total_requested_investors:0}</div>
												</div>
											</div>
											}
											{
											allOfferingDetails &&

											<div className="row">
												<div className="col-md-8">
												<div style={{fontSize: 16,fontWeight: 'bold',color: '#678899',marginTop: 10}}>Average Requested Amount : </div>
												</div>
												<div className="col-md-4">
												<div style={{fontSize: 16,fontWeight: 'bold',color: '#678899',marginTop: 10}}>{numberWithCommasAndDollar(allOfferingDetails.total_requested_amount/allOfferingDetails.total_requested_investors)}</div>
												</div>
											</div>
											}
										</div>
									</div>
								</div>
								</div>
							</div>
							</div>
						</div>
						<div className="row offering-detail-content">
							<div className="col-md-6">
								<div style={{marginTop:30,padding: 10, border: '1px solid #ddd'}}>{headers}</div>
								<div className="offering-detail-table">
									<GridTable
										columns={this.state.cols}
										rows={customerFilter}
										isPaginated={true}
										isVirtualScroll={true}
										showSearch={true}
										showRowsInformation={false}
										isHeaderSticky={true}
									/>
								</div>
							</div>
							<div className="col-md-6" style={{marginTop:20}}>
								<div style={{width: '100%', height: '400px', textAlign: 'center'}}>
									<div style={{width: '100%', height: '100%'}}>
										<ResponsiveContainer width="100%" height="100%">
											<LineChart
											data={chartData}
											margin={{ top: 40, right: 40, bottom: 20, left: 70 }}
											>
											<CartesianGrid vertical={true} stroke="#eee" strokeDasharray="5 5"/>

											<XAxis dataKey="Date" tickFormatter={this.formatXAxis}>
												<Label value="Order Date" angle={0} position='bottom' style={{ textAnchor: 'middle',fontSize: 18,fontWeight: 'bold',color:'#0A5074' }}>
												</Label>
											</XAxis>

											<YAxis unit='$'><Label value="Aggregate Requested Amount" angle={-90}  position='left' offset={140} style={{ textAnchor: 'middle',fontSize: 18,fontWeight: 'bold',color:'#0A5074' }}></Label></YAxis>

											<Tooltip
												content={this.renderTooltip}
												wrapperStyle={{
												borderColor: 'white',
												boxShadow: '2px 2px 3px 0px rgb(204, 204, 204)',
												}}
												contentStyle={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}
												labelStyle={{ fontWeight: 'bold', color: '#666666' }}
											/>

											<Line type="monotone" dataKey="Amount" stroke="#8DC73F" fill="#8DC73F" dot={<CustomizedDot />} activeDot={{ onClick:this.handleClick }} />

											</LineChart>
										</ResponsiveContainer>
										<div className="noOfInvestor"># No. of Investors</div>
									</div>
								</div>
								<div className="offering-detail-amountbox">
									<div className="row" style={{ marginTop: 10 }}>
									<div className="col-md-8">
										<div style={{fontSize: 16,fontWeight: 'bold',color: '#678899'}}>Largest order amount : </div>
									</div>
									<div className="col-md-4">
										<div style={{fontSize: 16,fontWeight: 'bold',color: '#678899'}}>{numberWithCommasAndDollar(largestOrder)}</div>
									</div>
									</div>
									<div className="row" style={{ marginTop: 10 }}>
									<div className="col-md-8">
										<div style={{fontSize: 16,fontWeight: 'bold',color: '#678899'}}>Smallest  order amount : </div>
									</div>
									<div className="col-md-4">
										<div style={{fontSize: 16,fontWeight: 'bold',color: '#678899'}}>{numberWithCommasAndDollar(smallestOrder)}</div>
									</div>
									</div>
									<div className="row" style={{ marginTop: 10 }}>
									<div className="col-md-8">
										<div style={{fontSize: 16,fontWeight: 'bold',color: '#678899'}}>Median of the order amounts : </div>
									</div>
									<div className="col-md-4">
										<div style={{fontSize: 16,fontWeight: 'bold',color: '#678899'}}>{numberWithCommasAndDollar(medianOrder)}</div>
									</div>
									</div>
									<div className="row" style={{ marginTop: 10 }}>
									<div className="col-md-8">
										<div style={{fontSize: 16,fontWeight: 'bold',color: '#678899'}}># of round lots (orders that are 100 shares or more)</div>
									</div>
									<div className="col-md-4">
										<div style={{fontSize: 16,fontWeight: 'bold',color: '#678899'}}>{hundreds}</div>
									</div>
									</div>
									<div className="row" style={{ marginTop: 10 }}>
									<div className="col-md-8">
										<div style={{fontSize: 16,fontWeight: 'bold',color: '#678899'}}># (orders that are $2500 or more)</div>
									</div>
									<div className="col-md-4">
										<div style={{fontSize: 16,fontWeight: 'bold',color: '#678899'}}>{twoPointFiveThousands}</div>
									</div>
									</div>
								</div>
							</div>

						</div>
						<Dialog
							onClose={this.closeOrderModal}
							aria-labelledby="customized-dialog-title"
							open={this.state.openOrderModal}
							maxWidth={"md"}
							fullWidth={true}
							scroll={'paper'}
							>
							<DialogTitle onClose={this.closeOrderModal} className="offering-detail-title">Orders</DialogTitle>
								<DialogContent>
									<div className="col-md-12 offering-detail-table">
										<GridTable
											columns={this.state.cols}
											rows={this.state.orderList}
											isPaginated={true}
											isVirtualScroll={true}
											showSearch={true}
											showRowsInformation={false}
											isHeaderSticky={true}
										/>
									</div>
								</DialogContent>
							</Dialog>
					</div>
				</div>
			</Dashboard>
		)
	}
}

OfferingInvestorsComponent.propTypes = {
	offeringDetailRes: PropTypes.any,
	offeringUserInfoRes: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
	offeringDetailRes: doOfferingDetailRes,
	offeringUserInfoRes: doOfferingUserInfoRes,
});

function mapDispatchToProps(dispatch) {
	return {
		getOfferingDetail: (data) => dispatch(getOfferingDetail(data)),
		fetchOfferingUserInfo: (data) => dispatch(fetchOfferingUserInfo(data)),
	};
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(OfferingInvestorsComponent);
